import _ from 'lodash';

export const SHOW_TOAST = 'notifications/SHOW_TOAST';
export const HIDE_TOAST = 'notifications/HIDE_TOAST';
export const RECORD_UNSUCCESSFUL_BACKEND_CALL =
  'notifications/RECORD_UNSUCCESSFUL_BACKEND_CALL';

export const showToast = ({uuid, ...obj}) => ({
  type: SHOW_TOAST,
  payload: {
    uuid,
    ...obj
  }
});

export const selectToasts = state => _.get(state, 'notifications.toasts');

export const hideToast = ({uuid}) => ({
  type: HIDE_TOAST,
  payload: {
    uuid
  }
});

export const recordUnsuccessfulBackendCall = ({actionObject}) => ({
  type: RECORD_UNSUCCESSFUL_BACKEND_CALL,
  payload: {
    actionObject
  }
});
export const selectUnsuccessfulBackendCalls = (
  state
): Array<UnsuccessfulBackendCall> => {
  return _.get(state, 'notifications.unsuccessfulBackendCalls', []);
};

interface ToasterToast {
  uuid: string;
  color?: string;
}
export interface UnsuccessfulBackendCall {
  actionType: string;
  occurrencesCounter: number;
}
const initialState: {
  unsuccessfulBackendCalls: UnsuccessfulBackendCall[];
  toasts: ToasterToast[];
} = {
  unsuccessfulBackendCalls: [],
  toasts: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST: {
      const {uuid, ...obj} = action.payload;

      const toasts = [
        ...state.toasts,
        {
          uuid: uuid,
          ...obj,
          isVisible: true
        }
      ];

      return {...state, toasts};
    }

    case HIDE_TOAST: {
      const {uuid} = action.payload;

      const toasts = state.toasts.map(toast => {
        if (toast.uuid == uuid) {
          return {
            ...toast,
            isVisible: false
          };
        }
        return toast;
      });

      return {...state, toasts};
    }

    case RECORD_UNSUCCESSFUL_BACKEND_CALL: {
      const {actionObject} = action.payload;

      let unsuccessulBackendCallObject = _.head(
        state.unsuccessfulBackendCalls.filter(
          x => x.actionType == actionObject.type
        )
      );

      if (!unsuccessulBackendCallObject) {
        unsuccessulBackendCallObject = {
          actionType: actionObject.type,
          occurrencesCounter: 1
        };
      } else {
        unsuccessulBackendCallObject.occurrencesCounter += 1;
      }

      const unsuccessfulBackendCalls = state.unsuccessfulBackendCalls.filter(
        obj => obj.actionType != actionObject.type
      );

      return {
        ...state,
        unsuccessfulBackendCalls: [
          ...unsuccessfulBackendCalls,
          unsuccessulBackendCallObject
        ]
      };
    }

    default:
      return state;
  }
};

export default reducer;
